import produce from "immer";
import { CustomizationState } from "../";
import { Content } from "../../../types/customization/content";

export interface SetSavedContentAction {
  content: Content;
  type: "setSavedContent";
}

export function setSavedContent(
  state: CustomizationState,
  action: SetSavedContentAction
): CustomizationState {
  return produce(state, (draftState) => {
    draftState.content = action.content;
  });
}
